import React from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer } from '../components/Layout';
import { ArrowLeft } from 'lucide-react';

const TermsPage = () => (
  <div className="min-h-screen bg-[#1A1A1A] flex flex-col">
    <Header />
    <main className="flex-1 max-w-3xl mx-auto px-4 py-8 w-full">
      <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-white mb-6 text-sm">
        <ArrowLeft className="h-4 w-4" /> Back to Home
      </Link>
      <h1 className="text-3xl font-black uppercase text-white mb-8" style={{ fontFamily: 'Outfit' }}>
        Terms of <span className="text-[#D4AF37]">Service</span>
      </h1>
      <div className="card-dark prose-invert space-y-6 text-gray-300 text-sm leading-relaxed">
        <p className="text-gray-400 text-xs">Last updated: April 2026</p>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">1. Acceptance of Terms</h2>
          <p>By accessing or using KrazyBets ("the Platform"), you agree to be bound by these Terms of Service. If you do not agree, you must not use the Platform. KrazyBets is owned and operated by Qfinity Media Group.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">2. Eligibility</h2>
          <p>You must be at least 18 years of age to use KrazyBets. By registering, you confirm you are of legal gambling age in your jurisdiction. KrazyBets reserves the right to verify your age and identity through our KYC (Know Your Customer) process.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">3. Account Registration</h2>
          <p>You must provide accurate and complete information during registration. You are responsible for maintaining the confidentiality of your account credentials. One account per person is permitted. Multiple accounts will result in suspension and forfeiture of funds.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">4. Peer-to-Peer Betting</h2>
          <p>KrazyBets operates as a peer-to-peer betting platform. Users bet against each other, not against the house. The Platform acts solely as a facilitator and escrow agent. All bets must be based on real-world, verifiable events. Bets on adult content, violence, minors, or illegal activities are strictly prohibited.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">5. Bet Rules</h2>
          <p>All bets must be binary (YES/NO outcome) and resolvable within 1 to 48 hours. The Initiator creates the bet, and the Challenger accepts it. All bets require admin approval before going live (typically reviewed within 1-30 minutes). Once a bet is matched, funds from both parties are held in escrow until the outcome is determined.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">6. Fees and Commissions</h2>
          <p>KrazyBets charges a commission on winnings based on your subscription tier:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Free tier: 10% commission on winnings</li>
            <li>Green tier ($5/month): 5% commission on winnings</li>
            <li>Gold tier ($10/month): 3% commission on winnings</li>
          </ul>
          <p className="mt-2">Expired unmatched bets are subject to a 10% unmatched fee upon refund.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">7. QBC Tokens (Qbean Tokens)</h2>
          <p>QBC tokens are the platform's digital currency used for betting. Tokens can be purchased via supported payment methods or earned through promotions. QBC tokens have no real-world cash value outside the Platform unless explicitly converted through approved withdrawal methods.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">8. Rock Paper Scissors (RPS)</h2>
          <p>RPS duels use a commit-reveal system to prevent cheating. Both players commit their moves cryptographically before revealing. Games are best-of-three with a 60-second time limit. If time expires, the leading player wins.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">9. Dispute Resolution</h2>
          <p>Disputes should be submitted through the Support Tickets system. KrazyBets administration will review all disputes within 48 hours. The admin's decision on bet outcomes is final. Users may request a moderator for high-stakes games.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">10. Prohibited Conduct</h2>
          <p>The following are strictly prohibited:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Creating bets on adult entertainment, sexual content, or pornography</li>
            <li>Betting on violence, killings, or harm to individuals</li>
            <li>Any bets involving minors or children</li>
            <li>Betting on illegal activities or substances</li>
            <li>Match-fixing, collusion, or manipulation of outcomes</li>
            <li>Using bots, scripts, or automated tools</li>
            <li>Creating multiple accounts</li>
            <li>Money laundering or fraudulent transactions</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">11. Account Suspension</h2>
          <p>KrazyBets reserves the right to suspend or terminate accounts that violate these Terms. Suspended accounts may have their funds frozen pending investigation. Repeated violations will result in permanent ban and forfeiture of funds.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">12. Limitation of Liability</h2>
          <p>KrazyBets is provided "as is" without warranties. The Platform is not responsible for losses incurred through betting. Users participate at their own risk. KrazyBets' total liability shall not exceed the balance in the user's account.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">13. Governing Law</h2>
          <p>These Terms are governed by the laws of South Africa. Any disputes shall be resolved in the courts of South Africa.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">14. Contact</h2>
          <p>For questions about these Terms, contact us at <a href="mailto:info@krazybets.online" className="text-[#D4AF37] hover:underline">info@krazybets.online</a></p>
        </section>

        <div className="border-t border-[#3D3D3D] pt-4 mt-8">
          <p className="text-gray-500 text-xs">© 2026 KrazyBets. All rights reserved. Owned and trademarked by Qfinity Media Group.</p>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default TermsPage;
